import { LoginView } from '@/widgets/Authentication/LoginView'

export const LoginPage = () => <LoginView />
